import useRouteName from "hooks/useRouteName";
import { createMicroConversionTrackingUtils } from "..";
import { useCallback } from "react";
import useProfiler from "hooks/useProfiler";

const utils = createMicroConversionTrackingUtils({
  name: "flights_web_sr_filter_unchecked_airlines",
  stages: {
    main: 1,
    direct: 2,
    meta: 3,
    oneway: 4,
    nononeway: 5,
    solo: 6,
    nonsolo: 7,
    us: 8,
    nonus: 9
  },
  defaultStage: 1,
  mainStage: 1,
  goals: {
    selectall: 1,
    unselectall: 2,
    interaction: 3,
    reset: 4
  },
  goalsWithValue: []
});

export default function useFlightsWebSrFilterUncheckedAirlines() {
  const routeName = useRouteName();

  const { isDirect, isOneWay, isSolo, isAmerican, isMobile } = useProfiler();

  const trackStages = useCallback(() => {
    isDirect() ? utils.stages.direct() : utils.stages.meta();
    isOneWay() ? utils.stages.oneway() : utils.stages.nononeway();
    isSolo() ? utils.stages.solo() : utils.stages.nonsolo();
    isAmerican() ? utils.stages.us() : utils.stages.nonus();
  }, [isDirect, isOneWay, isSolo, isAmerican]);

  const isVariant = useCallback(() => {
    if (
      !(
        (isMobile() && routeName === "searchresults") ||
        (!isMobile() && ["flightdetails", "searchresults"].includes(routeName))
      )
    )
      return false;
    trackStages();
    return utils.trackWithDefaultStage();
  }, [routeName, trackStages, isMobile]);

  return {
    isVariant,
    goals: { ...utils.goals }
  };
}
